// src/services/hud/AbilityHUD.ts
import { global } from '../../core/GlobalState';
// TODO ABILITY HUD REFACTOR:
// Current implementation is simple and works, but consider refactoring into an AbilityHUD class or singleton if:
// - You need to dynamically rebuild, reset, or destroy the HUD during runtime (e.g., mode switches, VR, multiplayer).
// - You want to properly manage event listeners and DOM cleanup to prevent memory leaks.
// - You plan to decouple HUD state from `global` for testing or extensibility.
// - You need theme swapping, layout changes, or dynamic ability sets in the future.
// For now, function-based is fine since the HUD is static and only initialized once.
//TODO use implicit numbers
export var AbilityMode;
(function (AbilityMode) {
    /* Basic Orb Operations */
    AbilityMode[AbilityMode["CreateOrb"] = 0] = "CreateOrb";
    AbilityMode[AbilityMode["DeleteObject"] = 1] = "DeleteObject";
    AbilityMode[AbilityMode["EditOrb"] = 2] = "EditOrb";
    /* Observation & Interaction */
    AbilityMode[AbilityMode["ActivateOrb"] = 3] = "ActivateOrb";
    AbilityMode[AbilityMode["MoveObject"] = 4] = "MoveObject";
    AbilityMode[AbilityMode["InspectObject"] = 5] = "InspectObject";
    /* Connections */
    AbilityMode[AbilityMode["CreateConnection"] = 6] = "CreateConnection";
    AbilityMode[AbilityMode["ToggleConnectionPresentation"] = 7] = "ToggleConnectionPresentation";
    /* Movement & Orb Traversal */
    AbilityMode[AbilityMode["AutoflyMode"] = 8] = "AutoflyMode";
    AbilityMode[AbilityMode["OrbitOrb"] = 9] = "OrbitOrb";
    AbilityMode[AbilityMode["WarpToOrb"] = 10] = "WarpToOrb";
    AbilityMode[AbilityMode["EnterOrb"] = 11] = "EnterOrb";
    /* Planeshifting */
    AbilityMode[AbilityMode["WarpDimension"] = 12] = "WarpDimension";
    AbilityMode[AbilityMode["RandomWarp"] = 13] = "RandomWarp";
    AbilityMode[AbilityMode["OrbSetInversion"] = 14] = "OrbSetInversion";
    /* Conjuration */
    AbilityMode[AbilityMode["CloneOrb"] = 15] = "CloneOrb";
    AbilityMode[AbilityMode["SummonOrbs"] = 16] = "SummonOrbs";
    AbilityMode[AbilityMode["GlobalOrbSearch"] = 17] = "GlobalOrbSearch";
    /* Creation */
    AbilityMode[AbilityMode["CreateSystemPortal"] = 18] = "CreateSystemPortal";
    AbilityMode[AbilityMode["ShootProjectile"] = 19] = "ShootProjectile";
    AbilityMode[AbilityMode["GenerateSphericalArrangement"] = 20] = "GenerateSphericalArrangement";
    /* Transformation */
    AbilityMode[AbilityMode["ExpandNestedOrbs"] = 21] = "ExpandNestedOrbs";
    AbilityMode[AbilityMode["SplitOrb"] = 22] = "SplitOrb";
    AbilityMode[AbilityMode["MergeOrbs"] = 23] = "MergeOrbs";
    AbilityMode[AbilityMode["GrowSelectedOrb"] = 24] = "GrowSelectedOrb";
    AbilityMode[AbilityMode["ShrinkSelectedOrb"] = 25] = "ShrinkSelectedOrb";
    AbilityMode[AbilityMode["AttractAllOrbs"] = 26] = "AttractAllOrbs";
    AbilityMode[AbilityMode["RepelOrbs"] = 27] = "RepelOrbs";
    /* Interface Utilities */
    AbilityMode[AbilityMode["OpenCodeWorkbench"] = 28] = "OpenCodeWorkbench";
    AbilityMode[AbilityMode["OpenCommandConsole"] = 29] = "OpenCommandConsole";
    /* Removed */
    //CreateBlackhole,
    //AttractSelectedOrbType,
    //CastSpell,
    //HookOrb,
    //UserSelectOrb,    
    //ApplyDagLayout,
})(AbilityMode || (AbilityMode = {}));
export function getAbilityList() {
    return Object.keys(AbilityMode)
        .filter(key => isNaN(Number(key)));
}
export function createAbilityBar() {
    const bar = document.getElementById('abilityBar');
    const abilities = getAbilityList();
    console.log('[AbilityHUD] Initializing ability bar', { abilityCount: abilities.length });
    const iconMap = {
        CreateOrb: 'sphere-plus.svg',
        EditOrb: 'tool.svg',
        ShootProjectile: 'arrow-big-up-lines.svg',
        DeleteObject: 'trash.svg',
        CreateConnection: 'exchange.svg',
        CreateRay: 'focus-2.svg',
        InspectObject: 'search.svg',
        WarpToOrb: 'location-bolt.svg',
        MoveObject: 'hand-grab.svg',
        EnterOrb: 'login.svg',
        SummonOrbs: 'cloud-down.svg',
        AttractSelectedOrbType: 'selector.svg',
        AttractAllOrbs: 'arrows-minimize.svg',
        RepelOrbs: 'arrows-maximize.svg',
        OrbitOrb: 'planet.svg',
        GenerateSphericalArrangement: 'circle-dotted.svg',
        ActivateOrb: 'hand-move.svg ',
        ToggleConnectionPresentation: 'dots-circle-horizontal.svg',
        ExpandNestedOrbs: 'affiliate.svg',
        CreateSystemPortal: 'home.svg',
        WarpDimension: 'alphabet-hebrew.svg',
        AutoflyMode: 'navigation-bolt.svg',
        OpenCodeWorkbench: 'code.svg',
        OpenCommandConsole: 'terminal-2.svg',
        ApplyDagLayout: 'mesh.svg',
        GrowSelectedOrb: 'circle-arrow-up.svg',
        ShrinkSelectedOrb: 'circle-arrow-down.svg',
        CloneOrb: 'circle-plus.svg',
        RandomWarp: 'zeta.svg',
        OrbSetInversion: 'mu.svg',
        SplitOrb: 'chart-bubble.svg',
        MergeOrbs: 'transform.svg',
        GlobalOrbSearch: 'search-orb.svg'
    };
    const labelMap = {
        CreateOrb: 'Create Orb',
        CreateSystemPortal: 'Create System Portal',
        EditOrb: 'Edit Orb',
        ShootProjectile: 'Shoot Projectile',
        DeleteObject: 'Delete Object',
        CreateConnection: 'Create Connection',
        ToggleConnectionPresentation: 'Toggle Connection Presentation',
        ActivateOrb: 'Activate Orb',
        MoveObject: 'Move Object',
        InspectObject: 'Inspect Object',
        WarpToOrb: 'Warp to Orb',
        EnterOrb: 'Enter Orb',
        SummonOrbs: 'Summon Orbs',
        GenerateSphericalArrangement: 'Generate Spherical Arrangement',
        AttractSelectedOrbType: 'Attract Selected Orb Type',
        AttractAllOrbs: 'Attract All Orbs',
        RepelOrbs: 'Repel Orbs',
        OrbitOrb: 'Orbit Orb',
        ExpandNestedOrbs: 'Expand Nested Orbs',
        CastSpell: 'Cast Spell',
        HookOrb: 'Hook Orb',
        UserSelectOrb: 'User Select Orb',
        WarpDimension: 'Warp Dimension',
        AutoflyMode: 'Toggle Autofly',
        OpenCodeWorkbench: 'Open Code Workbench',
        OpenCommandConsole: 'Open Command Console',
        ApplyDagLayout: 'Apply DAG Layout',
        GrowSelectedOrb: 'Grow Selected Orb',
        ShrinkSelectedOrb: 'Shrink Selected Orb',
        CloneOrb: 'Clone Orb',
        RandomWarp: 'Random Warp',
        OrbSetInversion: 'Orb Set Inversion',
        SplitOrb: 'Split Orb',
        MergeOrbs: 'Merge Orbs',
        GlobalOrbSearch: 'Global Orb Search'
    };
    abilities.forEach((abilityName, index) => {
        var _a;
        const slot = document.createElement('div');
        slot.className = 'ability-slot';
        slot.dataset.index = String(index);
        bar.appendChild(slot);
        const iconFilename = iconMap[abilityName];
        const friendlyName = (_a = labelMap[abilityName]) !== null && _a !== void 0 ? _a : abilityName;
        slot.title = friendlyName;
        slot.setAttribute('aria-label', friendlyName);
        if (!iconFilename) {
            // No icon for this ability — leave slot blank
            return;
        }
        const iconPath = `/public/icons/${iconFilename}`;
        fetch(iconPath)
            .then(response => response.text())
            .then(svgText => {
            slot.innerHTML = svgText;
        })
            .catch(err => {
            console.error(`Failed to load SVG for ${abilityName}:`, err);
        });
    });
    updateAbilityBarHighlight();
    console.log('[AbilityHUD] Ability bar ready');
}
export function updateAbilityBarHighlight() {
    const slots = document.querySelectorAll('.ability-slot');
    slots.forEach((slot, idx) => {
        if (idx === global.clickMode) {
            slot.classList.add('selected');
        }
        else {
            slot.classList.remove('selected');
        }
    });
}
